export const searchBarBorderColor = "  #dadadaaa";
export const white = "#FFFFFF";
export const secondaryTextColor = "#7A869A";
export const primaryBlue = "#2A7CED";
export const primaryGray = "#707070";
export const lightGray = "#e0e0e0";
export const filterTitle = "#111111";
export const textBarColor = "#FFFFFF";
export const primaryRed = "#FF3636";

